export const ALLOWED_SHAFT_MACHINING_CODES = [
  // LEFT / RIGHT
  "000",
  "001",
  "003",
  "005",
  "007",
  // MIDDLE
  "900",
  "980",
];
export const METRIC_UNIT = "mm";
export const INCH_UNIT = "″";

export const MACHINING_CODES_WITH_HOLES = ["003", "007", "980"];
export const MACHINING_CODES_WITHOUT_HOLES = ["000", "001", "005", "900"];
